import {Component} from "react";
import Footer from "../footer";
import React from "react";
import {MyMixin} from "../footer"

class SterlingJewelersFooter extends MyMixin(Component) {

    render() {
        super.render();
        return (
            <div className="sterlingjewelers-footer">
                <div className="footer-container">
                    <div className="footer-ctas">
                        <div className="footer-cta__wrap">
                            <div className="footer-contact">
                                <div className="footer-contact__content">
                                    <div className="footer-contact__options ui-g">
                                        <div
                                            className="footer-contact-option show-for-xlarge-up ui-g-12 ui-md-4 ui-lg-4">
                                            <div className="footer-top">
                                                <div>
                                                    <img alt="icon giftbox"
                                                        src="https://www.sterlingjewelers.com/static_assets/media/sterlingjewelers/footer_2/icon-giftbox.png"/>
                                                </div>
                                                <div className="footer-cta__desc medium-10 large-12 xlarge-9 columns">
                                                    <h2>Sterling Jewelers Gift Cards</h2>
                                                    <p>Looking for the perfect present? Give the gift that always
                                                        fits.</p>
                                                    <p><a className="hero__link "
                                                          href="https://www.sterlingjewelers.com/en/sterlingjewelersstore/FindAStoreView?storeId=10603&amp;langId=-1&amp;catalogId=10001"
                                                          title="Buy a Gift Card"
                                                          target="_top"> Visit your local store </a>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="footer-contact-option ui-g-12 ui-md-4 ui-lg-4">
                                            <div className="footer-top">
                                                <div>
                                                    <img alt="icon-dollar"
                                                        src="https://www.sterlingjewelers.com/static_assets/media/sterlingjewelers/footer_2/icon-dollar.png"/>
                                                </div>
                                                <div className="footer-cta__desc medium-10 large-12 xlarge-9 columns">
                                                    <h2>Get Prequalified Now</h2>
                                                    <p>Get the credit you deserve. It's safe, secure and can be yours -
                                                        fast.</p>
                                                    <p><a className="hero__link "
                                                          href="https://www.sterlingjewelers.com/en/sterlingjewelersstore/cms/credit-landing"
                                                          title="Get Prequalified Now!"
                                                          target="_top">Get Prequalified Now!</a>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="footer-contact-option ui-g-12 ui-md-4 ui-lg-4">
                                            <div className="footer-top">
                                                <div>
                                                    <img alt="icon-diamond"
                                                        src="https://www.sterlingjewelers.com/static_assets/media/sterlingjewelers/footer_2/icon-diamond~1.png"/>
                                                </div>
                                                <div className="footer-cta__desc medium-10 large-12 xlarge-9 columns">
                                                    <h2>Expert Jewelry Advice</h2>
                                                    <p>For jewelry tips, tools and advice visit</p>
                                                    <p><a className="hero__link "
                                                          href="https://www.sterlingjewelers.com/en/sterlingjewelersstore/FindAStoreView?storeId=10603&amp;langId=-1&amp;catalogId=10001"
                                                          title="Jewelry Wise "
                                                          target="_top"> Jewelry Wise </a>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="footer-bottom">
                        <div className="footer-ctas">
                            <div className="footer-cta__wrap">
                                <div>
                                    <div className="footer-left" style={!this.isMobileLayout ? {float: 'left'} : {}}>
                                        <div>
                                            <a href="https://www.sterlingjewelers.com/en/sterlingjewelersstore#">
                                                <i className="fa fa-desktop"></i>
                                                &nbsp;&nbsp;Order Status
                                            </a>
                                        </div>
                                        <div>
                                            <a href="https://www.sterlingjewelers.com/en/sterlingjewelersstore/FindAStoreView?storeId=sterlingjewelers&langId=-1&catalogId=10001">
                                                <i className="fa fa-map-marker fa-lg"></i>
                                                &nbsp;&nbsp;Store Locator
                                            </a>
                                        </div>
                                    </div>
                                    <div>
                                        <Footer uiGridClasses="ui-g-12 ui-md-6 ui-lg-3" model={this.props.model}
                                                isSmallSize={window.innerWidth < 760}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {!this.isMobileLayout &&
                <div>
                    <div className="brand-logos ui-g">
                        <div className="brand-logos-item">
                            <img alt="JBR Logo"
                                src="https://www.sterlingjewelers.com/static_assets/media/sterlingjewelers/footer_2/logos/Image-jbr-logo.png"/>
                        </div>
                        <div className="brand-logos-item">
                            <img alt="Morgan Logo"
                                src="https://www.sterlingjewelers.com/static_assets/media/sterlingjewelers/footer_2/logos/Image-marks-morgan-logo.png"/>
                        </div>
                        <div className="brand-logos-item">
                            <img alt="Shaws Logo"
                                src="https://www.sterlingjewelers.com/static_assets/media/sterlingjewelers/footer_2/logos/Image-shaws-logo.png"/>
                        </div>
                        <div className="brand-logos-item">
                            <img alt="Belden Logo"
                                src="https://www.sterlingjewelers.com/static_assets/media/sterlingjewelers/footer_2/logos/Image-belden-logo.png"/>
                        </div>
                        <div className="brand-logos-item">
                            <img alt="Osterman Logo"
                                src="https://www.sterlingjewelers.com/static_assets/media/sterlingjewelers/footer_2/logos/Image-osterman-logo.png"/>
                        </div>
                        <div className="brand-logos-item">
                            <img alt="Weisfield Logo"
                                src="https://www.sterlingjewelers.com/static_assets/media/sterlingjewelers/footer_2/logos/Image-weisfield-logo.png"/>
                        </div>
                        <div className="brand-logos-item">
                            <img alt="Leroys Logo"
                                src="https://www.sterlingjewelers.com/static_assets/media/sterlingjewelers/footer_2/logos/Image-leroys-logo.png"/>
                        </div>
                        <div className="brand-logos-item">
                            <img alt="Rogers Logo"
                                src="https://www.sterlingjewelers.com/static_assets/media/sterlingjewelers/footer_2/logos/Image-rogers-logo.png"/>
                        </div>
                        <div className="brand-logos-item">
                            <img alt="Goodman Logo"
                                src="https://www.sterlingjewelers.com/static_assets/media/sterlingjewelers/footer_2/logos/Image-goodman-logo.png"/>
                        </div>
                    </div>

                    <div className="footer-legal">
                        <div className="fl">
                            <ul>
                                <li><a className="hero__link "
                                       href="https://www.sterlingjewelers.com/en/sterlingjewelersstore/cms/privacy-policy"
                                       target="_top" title="Privacy Policy - Updated"> Privacy Policy - Updated </a>
                                </li>
                                <li><a className="hero__link "
                                       href="https://www.sterlingjewelers.com/en/sterlingjewelersstore/cms/sterling-legal-disclaimers"
                                       target="_top" title="Terms of Use"> Terms of Use </a></li>
                                <li><a className="hero__link "
                                       href="/webapp/wcs/stores/servlet/SiteMapView?storeId=10603&amp;urlRequestType=Base&amp;langId=-1&amp;catalogId=10001"
                                       title="Site Map" target="_top"> Site Map </a>
                                </li>
                                <li style={{
                                    left: '700px',
                                    position: 'relative',
                                    color: 'white',
                                    fontSize: '10px'
                                }}>©2000-2018 Sterling Jewelers Inc.
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                }
                {this.isMobileLayout &&
                <div className="footer-legal" style={{background: '#384855'}}>
                    <div className="fl">
                        <ul>
                            <li><a className="hero__link "
                                   href="https://www.sterlingjewelers.com/en/sterlingjewelersstore/cms/privacy-policy"
                                   target="_top" title="Privacy Policy - Updated"> Privacy Policy - Updated </a>
                            </li>
                            <li><a className="hero__link "
                                   href="https://www.sterlingjewelers.com/en/sterlingjewelersstore/cms/sterling-legal-disclaimers"
                                   target="_top" title="Terms of Use"> Terms of Use </a></li>
                            <li><a className="hero__link "
                                   href="/webapp/wcs/stores/servlet/SiteMapView?storeId=10603&amp;urlRequestType=Base&amp;langId=-1&amp;catalogId=10001"
                                   title="Site Map" target="_top"> Site Map </a>
                            </li>
                        </ul>
                        <div>
                            <div style={{
                                textAlign: 'center',
                                color: 'white',
                                fontSize: '10px',
                                paddingBottom: '10px'
                            }}>©2000-2018 Sterling Jewelers Inc.
                            </div>
                        </div>
                    </div>
                </div>
                }
            </div>
        )
    }
}

export default SterlingJewelersFooter



// WEBPACK FOOTER //
// ./src/site_interfaces/footers/sterlingjewelers.js